// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".order-portray-content[data-v-22dd39fc]{height:800px;overflow-y:auto;border-left:1px solid #6d737b}", ""]);
// Exports
module.exports = exports;
